import { Modal } from "react-bootstrap";
import CompanyForm from "../../Pages/Forms/CompanyForm";

const AddCompany = (props) => {
	return (
		<Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter">
			<Modal.Header closeButton>
				<h3 className="fw-bold">Add a new company</h3>
			</Modal.Header>

			<Modal.Body>
				<div className="bg-white rounded">
					<CompanyForm newData={true} />

					<div className="d-flex justify-content-end mt-n3">
						<button
							className="btn btn-danger px-sm-5 mt-n4"
							onClick={props.onHide}
						>
							Cancel
						</button>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default AddCompany;
